import { useQuery } from '@tanstack/react-query';

import { fetchCargoClaimHistoryApi } from '../api';

export default function useCargoClaimHistoryQuery(
  reference?: string,
  options?: any
) {
  return useQuery(
    ['cargo', 'claim', 'history', reference],
    fetchCargoClaimHistoryApi,
    { enabled: Boolean(reference), ...options }
  );
}
